import { render, staticRenderFns } from "./DetailIndex.vue?vue&type=template&id=70132c8a&scoped=true"
import script from "./DetailIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DetailIndex.vue?vue&type=style&index=0&id=70132c8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70132c8a",
  null
  
)

export default component.exports